import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "~/router";
import BackButton from "~/screens/Auth/components/BackButton";
import { AuthLayout } from "~/screens/Auth/Layout/AuthLayout";
import { useVisitType } from "~/screens/Scheduling/PersonalInformation/hooks/use-visit-type";
import { PATIENT_STATUS, useStartBookingFlow, VISIT_TYPES } from "~/services";
import { Button, Title } from "~/shared";
import { CoachImage } from "~/shared/assets";
import { usePatientStore } from "~/stores";
import { icons } from "~/ui";
import { useRedirect } from "~/utils";

const benefits = [
  "Build a wellness plan with lifestyle recommendations for your top symptoms",
  "Provide emotional and educational support",
  "Help you prepare for visits with clinicians and know what questions to ask",
];

export const MeetCoach = () => {
  const { setVisitType } = useVisitType();

  useStartBookingFlow({ visitType: VISIT_TYPES.COACH });

  const redirectTo = useRedirect();
  const navigate = useNavigate();
  const setPatientType = usePatientStore((s) => s.setPatientType);
  const isRescheduling = usePatientStore((s) => s.isRescheduling);
  const setIsRescheduling = usePatientStore((s) => s.setIsRescheduling);

  const handleRedirect = () => {
    setPatientType(PATIENT_STATUS.COACH);
    redirectTo(ROUTES.getStartedInsurance);
  };

  const goHome = () => {
    setIsRescheduling(false);
    navigate(ROUTES.hubHome);
  };

  useEffect(() => {
    setVisitType(VISIT_TYPES.COACH);
  }, []);

  return (
    <AuthLayout>
      <main className="mx-auto md:max-w-lg">
        <header>
          <BackButton
            variant="violet"
            to={isRescheduling ? goHome : ROUTES.hubBookVisit}
          />
          <Title>Work with a coach</Title>
        </header>

        <div className="flex justify-center">
          <img src={CoachImage} alt="Elektra coaches" className="w-full" />
        </div>
        <section className="text-midnight-indigo flex flex-col gap-4 py-6 text-sm md:text-base">
          <p className="font-medium">Elektra coaches are here to</p>
          <ul className="flex flex-col gap-3">
            {benefits.map((text) => (
              <li key={text} className="flex items-start gap-3">
                <icons.solid.CheckCircleIcon className="text-success size-6 shrink-0" />
                <span>{text}</span>
              </li>
            ))}
          </ul>
        </section>

        <Button onClick={handleRedirect} className="w-full">
          Continue
        </Button>
      </main>
    </AuthLayout>
  );
};
